import React, { ReactElement } from 'react';
import { isDarkMode } from 'utils/helpers';

interface RequestInformationIconProps {
  fillColor?: string;
}

const RequestInformationIcon = ({ fillColor = '#D9D9D9' }: RequestInformationIconProps): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="26" viewBox="0 0 27 26" fill="none">
      <mask
        id="mask0_3941_18852"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="27"
        height="26"
      >
        <rect x="0.5" width="26" height="26" fill={fillColor} />
      </mask>
      <g mask="url(#mask0_3941_18852)">
        <path
          d="M19.9999 21.8735L18.276 20.1495L19.8333 18.5652H15.5176V16.1006H19.8333L18.276 14.5162L19.9999 12.7923L24.5405 17.3329L19.9999 21.8735ZM4.98219 18.5652C4.3 18.5652 3.71869 18.3249 3.23827 17.8445C2.75781 17.3641 2.51758 16.7828 2.51758 16.1006V5.56517C2.51758 4.88298 2.75781 4.30167 3.23827 3.82125C3.71869 3.34081 4.3 3.10059 4.98219 3.10059H18.7676C19.4498 3.10059 20.0311 3.34081 20.5115 3.82125C20.992 4.30167 21.2322 4.88298 21.2322 5.56517V10.8181C21.0257 10.7734 20.8203 10.7398 20.616 10.7175C20.4117 10.6951 20.2064 10.6839 19.9999 10.6839C19.7934 10.6839 19.5881 10.6917 19.3838 10.7072C19.1795 10.7227 18.9741 10.7528 18.7676 10.7976V7.21785L11.7666 12.0976L4.98219 7.24493V16.1006H13.4581C13.4133 16.3157 13.3843 16.5254 13.371 16.7297C13.3576 16.934 13.3509 17.135 13.3509 17.3329C13.3509 17.5307 13.361 17.7329 13.3812 17.9393C13.4015 18.1458 13.434 18.3544 13.4787 18.5652H4.98219ZM6.86391 5.56517L11.7666 9.0807L16.8123 5.56517H6.86391Z"
          fill={isDarkMode() ? '#71B5E4' : '#0D5C93'}
        />
      </g>
    </svg>
  );
};

export default RequestInformationIcon;
